// Service for opening a confirmation dialog

import { Injectable, inject } from '@angular/core';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationDialogService {
  private dialog = inject(MatDialog);

  dialogRef: MatDialogRef<ConfirmationDialogComponent>;

  public flow: string;
  public keyword: string;
  public confirmMessage: string;

  public open(message?: string) {
    console.log('dialog');
    this.dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: false,
      autoFocus: true,
      panelClass: 'custom-modalbox',
    });
    this.dialogRef.componentInstance.confirmMessage =
      message || this.confirmMessage || `Are you sure you want to publish updates to ${this.flow} - ${this.keyword}?`;

    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }
}
